import type { CountryCode } from '@/models/country';

/**
 * Shared home-page example: 10 teams in list order (rank 1 → 10).
 * 4 seeds, 4 intermediates, 2 outsiders — matches game rules for `countryListValid`.
 */
export const HOME_DEMO_10_TEAMS: readonly CountryCode[] = [
  'FR',
  'DE',
  'GB_ENG',
  'AR',
  'AU',
  'JP',
  'CO',
  'SN',
  'GH',
  'NZ',
];

export const HOME_DEMO_SELECTED_SEEDS: readonly CountryCode[] = ['FR', 'DE', 'GB_ENG', 'AR'];
export const HOME_DEMO_SELECTED_INTERMEDIATES: readonly CountryCode[] = ['AU', 'JP', 'CO', 'SN'];
export const HOME_DEMO_SELECTED_OUTSIDERS: readonly CountryCode[] = ['GH', 'NZ'];
